// Dependencies
require("webstrap/type");
require("grid");
require("element/rich-text");

// Copy images
require("!!asset!./img/marker.png");

// Styles
require("./map.scss");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/map/index.js
 ** module id = 178
 ** module chunks = 0 1
 **/